import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds,
} from "../../Ads";
import { SERVER_URL } from "./ConstantsWomenCalculator";
import { DueDate_EndPoint } from "./ConstantsWomenCalculator";
import { CyrcleLengthcomponet } from "./Component";
import { DueDateTable } from "./Tables";
import SharedHelmet from "../Helmet";
const TITLE = " حاسبة  موعد الولادة المتوقع  ";
const DESCRIPTION =
  "حاسبة تاريخ الولادة: حدد موعد استحقاقكِ بدقة! أدخلي تاريخ آخر دورة شهرية (LMP) أو موعد التلقيح لمعرفة تاريخ الولادة المتوقع - مع توضيح مراحل الحمل بالأسبوع والشهر!";
const KEYWORDS = "تاريخ الولادة, حساب تاريخ الولادة, تاريخ الولادة المتوقعة ";
const OG_URL = "https://do-calculate.com/calculator/ar/pregnancy-due-date/";
const apiEndpoint = `${SERVER_URL}/${DueDate_EndPoint}`;
function DueDate() {
  const [firstDayOfLastPeriod, setFirstDate] = useState();
  const [periodLength, setPeriodLength] = useState(1);
  const [cycleLength, setCyrcleLength] = useState(28);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const handleDateChange = (event) => {
    setFirstDate(event.target.value);
  };
  const calculateDueDate = async () => {
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstDayOfLastPeriod,
          cycleLength,
          periodLength,
        }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{fontSize:'18px'}}> حساب تاريخ الولادة </h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                يستمر الحمل بمعدل 280 يومًا (40 أسبوعًا) من اليوم الأول من آخر
                دورة شهرية لك (LMP). ويعتبر اليوم الأول من الدورة الشهرية هو
                اليوم الأول من الحمل، على الرغم من أنك ربما لم تحملي إلا بعد
                مرور حوالي أسبوعين (يتأخر نمو الجنين أسبوعين عن مواعيد الحمل).
                إن حساب موعد ولادتك ليس علماً دقيقاً. عدد قليل جدًا من النساء
                يلدن في الواقع في موعد ولادتهن. وعلى الرغم من ضرورة أن يكون لديك
                فكرة عن موعد ولادة طفلك، فتوقعي ظهور العديد من العوامل التي تؤثر
                على موعد الولادة المتوقع. لحساب موعد الولادة التقريبي، تحتاجين
                إلى معرفة اليوم الأول من آخر دورة لك لاستخدام هذه الحاسبة. إذا
                كنت لا تعرفين ذلك أو كنت غير متأكدة، تحدثي إلى طبيبك.
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة تاريخ الولادة
                </div>
                <hr />
                <br />
                <div className=" form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label className="form-label ms-2">
                      <strong>أول يوم</strong> في آخر دورة شهرية
                    </label>
                  </b>
                  <br />
                  <input
                    type="date"
                    id="weightNumber"
                    value={firstDayOfLastPeriod}
                    onChange={handleDateChange}
                    className="form-control ml-2"
                    style={{ width: "145px" }}
                    placeholder="175"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="CycleLength" className="form-label ms-2">
                      متوسط الوقت بين الدورات
                    </label>
                  </b>
                  <CyrcleLengthcomponet handleDateChange={setCyrcleLength} />
                  <div className="input-group-append">
                    <span className="input-group-text ">يوم</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateDueDate}
                  >
                    إحسب{" "}
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        النتائج:{" "}
                      </div>
                    </h4>
                    <hr />
                    <DueDateTable result={result}></DueDateTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">وصف حاسبة تاريخ الولادة : </div>
              <div className="info-section-body">
                <u>
                  <h2>تقدير تاريخ الاستحقاق</h2>{" "}
                </u>
                <br />
                تاريخ الاستحقاق، المعروف أيضًا بتاريخ الولادة المقدر، هو تقدير
                لموعد ولادة المرأة الحامل. بينما يتم تقدير تاريخ الاستحقاق عادةً
                كتاريخ واحد، فإنه من المفيد أن نأخذ في الاعتبار نطاقًا من تواريخ
                الاستحقاق، حيث يحدث فقط 4% من الولادات في التاريخ المقدر
                للاستحقاق.
                <br/>                يمكن تقدير تواريخ الاستحقاق باستخدام عدة طرق مختلفة، بما في ذلك
                آخر دورة شهرية، الأشعة فوق الصوتية، تاريخ الحمل، وتاريخ نقل
                الأجنة المجهري (IVF).
                <br/>                <u>
                  <b>آخر دورة شهرية</b>{" "}
                </u>
                <br />
                الاعتماد الافتراضي لهذا المحوّل يستند إلى آخر دورة شهرية للمرأة
                (LMP)، بناءً على افتراض أن الولادة في المتوسط تحدث في عمر الحمل
                (عمر الحمل المحسوب من آخر دورة شهرية للمرأة) وهو 280 يومًا أو 40
                أسبوعًا. على الرغم من وجود بعض الجدل حول متى تبدأ الحمل بشكل
                فني، سواء عند تخصيب البويضة (التلقيح) أو عند التصاق البويضة
                بالرحم (التغريب)، إلا أن عمر الحمل لا يتغير بناءً على تعريفات
                مختلفة للحمل لأنه يعتمد على آخر دورة شهرية. من حيث عمر الحمل،
                تستمر الحملات عادة بين 37 و 42 أسبوعًا، مع استخدام 40 أسبوعًا
                كتقدير شائع في الحسابات. وبالتالي، يتم ت
                <br/>                <u>
                  <b>تاريخ الاستحقاق كنقطة مرجعية</b>{" "}
                </u>
                <br />
                عمومًا، لا يُعد توقيت ولادة الطفل ضمن النطاق الزمني من 37 إلى 42
                أسبوعًا سببًا للقلق. الأطفال الولادة بين الأسبوع 37-39، 39-41، و
                41-42 يُعتبرون مولودين مبكراً، مولودين في الوقت المناسب،
                ومولودين في وقت متأخر على التوالي. في ظروف طبيعية، يمكن أن يكون
                الأطفال الولادة في أيٍ من هذه الفترات بحالة صحية جيدة، على الرغم
                من أن الأطفال الولادة في الوقت المناسب عمومًا لديهم نتائج أفضل.
                يُعتبر الأطفال الولادة قبل الأسبوع 37 مبكرين، في حين يُعتبر
                الأطفال الولادة بعد الأسبوع 42 في وقت متأخر. هذه الفترات مهمة
                كنقطة مرجعية للأطباء لتحديد ما إذا كان هناك حاجة لأي إجراء. على
                سبيل المثال، إذا دخلت المرأة في ولادة مبكرة جدًا في الأسبوع 33،
                قد يتوقف الأطباء الوضع لتجنب ولادة طفل مبكر يمكن أن يعاني من
                مجموعة من المشاكل الصحية نتيجة للتخلف في النمو. وعلى النقيض، إذا
                لم تدخل المرأة في ولادة بعد الأسبوع 42، قد يقوم الأطباء بتحفيز
                الولادة. واحدة من المضاعفات المحتملة للسماح للحمل بالاستمرار بعد
                الأسبوع 42 هو أن المشيمة، المسؤولة عن توفير التغذية والأوكسجين
                للطفل، يمكن أن تتوقف عن العمل بشكل صحيح، بينما يستمر الطفل في
                النمو (متطلبًا مزيدًا من العناصر الغذائية والأوكسجين)، مما سيؤدي
                في النهاية إلى وجود نقط
                <br/>                <hr />
                <b>تاريخ اخر مراجعة : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default DueDate;
